import React, { useState, useEffect } from 'react';
import styles from './sections.module.css';
import { publicSiteAPI } from '../../../services/api';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface MediaGallerySectionProps {
  slug: string;
}

export const MediaGallerySection: React.FC<MediaGallerySectionProps> = ({ slug }) => {
  const ref = useScrollReveal();
  const [media, setMedia] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMedia();
  }, [slug]);

  const loadMedia = async () => {
    try {
      const data = await publicSiteAPI.getMedia(slug);
      setMedia(data || []);
    } catch {
      // silent fail
    } finally {
      setLoading(false);
    }
  };

  if (loading || media.length === 0) return null;

  return (
    <section id="media" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Media</h2>
        <div className={styles.mediaGrid}>
          {media.map((item: any, i: number) => (
            <div key={item._id || i} className={styles.mediaCard}>
              {item.thumbnail?.url || item.file?.url ? (
                <div className={styles.mediaImage}>
                  <img
                    src={item.thumbnail?.url || item.file?.url}
                    alt={item.title}
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className={styles.mediaPlaceholder}>
                  <span>{item.type || 'Media'}</span>
                </div>
              )}
              <div className={styles.mediaInfo}>
                <h4>{item.title}</h4>
                {item.description && <p>{item.description}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
